import { TransformRuleType } from "../../../types/transformation/TransformationRuleTypes";
import { Lowercase, LowercaseData } from "../Lowercase";
import { ReplaceAll, ReplaceAllData } from "../ReplaceAll";
import { ReplaceDate, ReplaceDateData } from "../ReplaceDate";
import { ReplaceFirst, ReplaceFirstData } from "../ReplaceFirst";
import { TransformRule, TransformRuleData } from "../TransformRule";
import { Uppercase, UppercaseData } from "../Uppercase";

export { TransformRuleFactory };

class TransformRuleFactory {
  static createRule(matcher: TransformRuleData): TransformRule {
    //console.trace('Creating TransformRule');
    switch (matcher.discriminator) {
      case "T_REPALL": {
        return ReplaceAll.createTest(matcher as unknown as ReplaceAllData);
      }
      case "T_REPFIRST": {
        return ReplaceFirst.createTest(matcher as unknown as ReplaceFirstData);
      }
      case "T_REPDATE": {
        return ReplaceDate.createTest(matcher as unknown as ReplaceDateData);
      }
      case "T_LCASE": {
        return Lowercase.createTest(matcher as unknown as LowercaseData);
      }
      case "T_UCASE": {
        return Uppercase.createTest(matcher as unknown as UppercaseData);
      }
      default: {
        throw new Error(`Unsupported Matcher Type ${matcher.discriminator}`);
      }
    }
  }

  static changeRule(rule: TransformRuleData, newType: TransformRuleType) {
    switch (newType) {
      case "T_REPALL": {
        return new ReplaceAll({
          discriminator: "T_REPALL",
          fieldName: rule.fieldName,
          position: rule.position,
          findPattern: "",
          replaceText: "",
        });
      }
      case "T_REPFIRST": {
        return new ReplaceFirst({
          discriminator: "T_REPFIRST",
          fieldName: rule.fieldName,
          position: rule.position,
          findPattern: "",
          replaceText: "",
        });
      }
      case "T_REPDATE": {
        return new ReplaceDate({
          discriminator: "T_REPDATE",
          fieldName: rule.fieldName,
          position: rule.position,
          inputDateFormat: "",
          targetFormat: "",
        });
      }
      case "T_LCASE": {
        return new Lowercase({
          discriminator: "T_LCASE",
          fieldName: rule.fieldName,
          position: rule.position,
        });
      }
      case "T_UCASE": {
        return new Uppercase({
          discriminator: "T_UCASE",
          fieldName: rule.fieldName,
          position: rule.position,
        });
      }
    }
  }
}
